import api from '@/services/api';

const CompanyContractTagCreate = {
  bulkCreateNotExistCompanyContractTasg: (companyContractTags) => {
    return api.post('bulk_create_not_exist_company_contract_tags/', {
      companyContractTags: companyContractTags
    });
  },
  createCompanyContractTag: (companyContractTagName, remarks, color) => {
    return api.post('create_company_contract_tag/', {
      companyContractTagName: companyContractTagName,
      remarks: remarks,
      color: color
    });
  }
};

export default CompanyContractTagCreate;
